module.exports = __webpack_public_path__ + "img/only_now.7a3f9461.png";